import { render } from "./PerformanceReport.vue?vue&type=template&id=7406af28&scoped=true"
import script from "./PerformanceReport.vue?vue&type=script&lang=js"
export * from "./PerformanceReport.vue?vue&type=script&lang=js"

import "./PerformanceReport.vue?vue&type=style&index=0&id=7406af28&scoped=true&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\34\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7406af28"]])

export default __exports__